var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLike = function SvgLike(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 18.4 18.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 18.48H.75a.75.75 0 0 1-.75-.75v-8a2.25 2.25 0 0 1 2.25-2.25h3.07l2.73-7a.75.75 0 0 1 .7-.48h1a2.75 2.75 0 0 1 2.75 2.73v3.25h3a2.74 2.74 0 0 1 2.73 3.12l-1 7a2.75 2.75 0 0 1-2.73 2.38m-13-1.5h13a1.26 1.26 0 0 0 1.24-1.08l.95-7a1.24 1.24 0 0 0-1.24-1.42h-3.7a.75.75 0 0 1-.75-.75v-4a1.26 1.26 0 0 0-1.25-1.25h-.49l-2.73 7a.75.75 0 0 1-.7.48H2.25a.75.75 0 0 0-.75.75z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export default ForwardRef;